import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const DiscountsDashboard = () => {
  return (
    <DashboardPageTemplate pageName={"discounts"} showCogsWarning={true} />
  );
};
